import { EUpdateDataFor } from "./action-interface/IPartnerNRSummaryDataActions";
import { PRIMARY_SUMMARY_DATA, SECONDARY_SUMMARY_DATA, } from "@redux/feature/PartnerNRDashboard/interface/PartnerNRSummaryData";
var PartnerNRDashboardPresenter = /** @class */ (function () {
    function PartnerNRDashboardPresenter(partnerNRDashboardUseCases, partnerNRDashboardActions) {
        this.partnerNRDashboardUseCases = partnerNRDashboardUseCases;
        this.partnerNRDashboardActions = partnerNRDashboardActions;
    }
    PartnerNRDashboardPresenter.prototype.getPartnerNRDownload = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.partnerNRDashboardUseCases.partnerNRDownload.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    PartnerNRDashboardPresenter.prototype.getPartnerNRHeader = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.partnerNRDashboardUseCases.partnerNRHeader.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    PartnerNRDashboardPresenter.prototype.getPartnerNRSummary = function (req, isComparing, updateDataFor) {
        var _this = this;
        this.partnerNRDashboardActions.partnerNRSummaryData.loader("PartnerNRSummaryData");
        this.partnerNRDashboardActions.partnerNRSummaryData.hideError("PartnerNRSummaryData");
        this.partnerNRDashboardUseCases.partnerNRSummary.execute({
            onSuccess: function (data) {
                if (isComparing && updateDataFor) {
                    switch (updateDataFor) {
                        case EUpdateDataFor.PRIMARY_DATA:
                            _this.partnerNRDashboardActions.partnerNRSummaryData.getPartnerNRSummaryData(data, "PartnerNRSummaryData", PRIMARY_SUMMARY_DATA);
                            break;
                        case EUpdateDataFor.SECONDARY_DATA:
                            _this.partnerNRDashboardActions.partnerNRSummaryData.getPartnerNRSummaryData(data, "PartnerNRSummaryData", SECONDARY_SUMMARY_DATA);
                            break;
                    }
                }
                else {
                    _this.partnerNRDashboardActions.partnerNRSummaryData.getPartnerNRSummaryData(data, "PartnerNRSummaryData", PRIMARY_SUMMARY_DATA);
                }
                _this.partnerNRDashboardActions.partnerNRSummaryData.stopLoader("PartnerNRSummaryData");
            },
            onError: function (error) {
                _this.partnerNRDashboardActions.partnerNRSummaryData.stopLoader("PartnerNRSummaryData");
                _this.partnerNRDashboardActions.partnerNRSummaryData.setError({
                    isOpen: true,
                    error: error,
                }, "PartnerNRSummaryData");
            },
        }, req);
    };
    return PartnerNRDashboardPresenter;
}());
export default PartnerNRDashboardPresenter;
